import { render } from "./Footer.vue?vue&type=template&id=5d794678&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5d794678&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d794678"

export default script